var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceCeterActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    width: 13.273,
    height: 26.546,
    viewBox: "0 0 13.273 26.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-settings-cell",
    "data-name": "Icon material-settings-cell",
    d: "M10.106,26.546h2.212V24.334H10.106Zm4.424,0h2.212V24.334H14.53Zm4.424,0h2.212V24.334H18.955ZM20.061.011,11.212,0A2.219,2.219,0,0,0,9,2.212v17.7a2.219,2.219,0,0,0,2.212,2.212h8.849a2.219,2.219,0,0,0,2.212-2.212V2.212a2.209,2.209,0,0,0-2.212-2.2Zm.737,19.9H10.475V2.95H20.8Z",
    transform: "translate(-9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCeterActive);
export default __webpack_public_path__ + "static/media/service-ceter-active.e6b4f11309249aeeb7203e6df473e3a5.svg";
export { ForwardRef as ReactComponent };